import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  IoChevronBackCircleOutline,
  IoChevronForwardCircleOutline,
} from "react-icons/io5";
import IconButton from "@material-ui/core/IconButton";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const tutorialSteps = [
  {
    label: "banner1",
    imgPath: "/images/banner4.jpg",
  },
  {
    label: "banner2",
    imgPath: "/images/banner4.jpg",
  },
  {
    label: "banner3",
    imgPath: "/images/banner4.jpg",
  },
  {
    label: "banner4",
    imgPath: "/images/banner4.jpg",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    position: "relative",

    "@media screen and (max-width: 480px)": {
      marginTop: "0px",
    },

    "@media screen and (min-width: 481px) and (max-width: 991px)": {
      marginTop: "0px",
    },

    "@media screen and (min-width: 992px) and (max-width: 1155px)": {
      marginTop: "0px",
    },

    "@media screen and (min-width: 1156px) and (max-width: 1401px)": {
      marginTop: "0px",
    },
    "@media screen and (min-width: 1402px) and (max-width: 1714px)": {
      marginTop: "0px",
    },
  },
  img: {
    display: "flex",
    overflow: "hidden",
    width: "100%",
  },
  contenedor: {
    /* display: "flex",*/
    height: "10%",
    backgroundColor: "transparent",
    display: "flex",
    position: "relative",
  },

  boton_derecha: {
    position: "absolute",
    display: "block",
    top: "38%",

    right: "20px",
    zIndex: 100,
    cursor: "pointer",
    userSelect: "none",

    fontSize: "50px",
    "&$disabled": {
      color: "rgb(198, 195, 195)",
    },
    "@media screen and (min-width: 781px) and (max-width: 1024px)": {
      transform: "translateX(-20%) translateY(-30%)",
      fontSize: "50px",
    },

    "@media screen and (min-width: 481px) and (max-width: 780px)": {
      transform: "translateX(15%) translateY(-20%)",
      fontSize: "40px",
    },

    "@media screen and (max-width: 480px)": {
      transform: "translateX(-110%) translateY(-50%)",
      fontSize: "30px",
    },
    color: "white",
  },

  disabled: {},

  boton_izquierda: {
    position: "absolute",
    display: "block",
    top: "50%",

    left: "72px",
    fontSize: "50px",
    transform: "translateX(-50%) translateY(-50%)",
    "&$disabled": {
      color: "rgb(198, 195, 195)",
    },
    "@media screen and (min-width: 781px) and (max-width: 1024px)": {
      transform: "translateX(-50%) translateY(-50%)",
      fontSize: "50px",
    },

    "@media screen and (min-width: 481px) and (max-width: 780px)": {
      transform: "translateX(-80%) translateY(-50%)",
      fontSize: "40px",
    },

    "@media screen and (max-width: 480px)": {
      transform: "translateX(-110%) translateY(-50%)",
      fontSize: "30px",
    },
    color: "white",
  },
}));

function Prueba() {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = tutorialSteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  return (
    <div className={classes.root}>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={6000}
        animateTransitions
      >
        {tutorialSteps.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 4 ? (
              <a
                href="https://inap.gob.gt/web/wp-content/uploads/2021/11/ULTIMA-VERSION-AGENDA-WEB-140-02-2022.pdf"
                target="_blank"
                rel="noopener"
              >
                {" "}
                <img
                  className={classes.img}
                  src={step.imgPath}
                  alt={step.label}
                />
              </a>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <div>
        <IconButton
          classes={{
            root: classes.boton_izquierda,
            disabled: classes.disabled,
          }}
          onClick={handleBack}
          disabled={activeStep === 0}
        >
          {theme.direction === "rtl" ? (
            <IoChevronBackCircleOutline className={classes.boton_izquierda} />
          ) : (
            <IoChevronBackCircleOutline />
          )}
        </IconButton>

        <IconButton
          classes={{
            root: classes.boton_derecha,
            disabled: classes.disabled,
          }}
          onClick={handleNext}
          disabled={activeStep === maxSteps - 1}
        >
          {theme.direction === "rtl" ? (
            <IoChevronForwardCircleOutline className={classes.boton_derecha} />
          ) : (
            <IoChevronForwardCircleOutline />
          )}
        </IconButton>
      </div>
    </div>
  );
}

export default Prueba;
